import React, { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  TextField,
  Typography,
  Button,
  Divider,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Icon } from "@iconify/react/dist/iconify.js";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { editJob, getAllGoals } from "../../../redux/features/appraisalSlice";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";

const JobsSelectionArea = ({ goal, jobActivityDisabled, dispatchData,adminView }) => {
  const [editMode, setEditMode] = useState(false);
  const [initialJobs, setInitialJobs] = useState([]);
  const [editedJobs, setEditedJobs] = useState([]);
  const [changeDetected, setChangeDetected] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setInitialJobs(goal.jobs);
    setEditedJobs(goal.jobs.map((job) => ({ ...job }))); //SHALLOW COPYING BASICALLY DOING THE SAMETHING BOTH INITIAL AND EDITED CONTAIN SAME ARRAY
  }, [goal]);

  const handleJobFieldEdit = (id, field, value) => {
    const updated = editedJobs.map((job) =>
      job.goal_job_id === id
        ? { ...job, [field]: value === false ? 0 : value === true ? 1 : value }
        : job
    );
    setEditedJobs(updated);
    checkForChanges(updated);
  };

  const checkForChanges = (updatedJobs) => {
    const hasChanges = updatedJobs.some(
      (job, idx) =>
        job.goal_job_name !== initialJobs[idx].goal_job_name ||
        job.goal_job_start_date !== initialJobs[idx].goal_job_start_date ||
        job.goal_job_end_date !== initialJobs[idx].goal_job_end_date ||
        job.goal_job_completed !== initialJobs[idx].goal_job_completed ||
        job.goal_job_striked !== initialJobs[idx].goal_job_striked
    );
    setChangeDetected(hasChanges);
  };

  const handleEditAll = () => {
    setEditMode(true);
  };

  const handleCancel = () => {
    const resetJobs = initialJobs.map((job) => ({ ...job }));
    setEditedJobs(resetJobs);
    setEditMode(false);
    setChangeDetected(false);
  };

  const handleUpdate = () => {
    
    const data = { data: editedJobs, id: goal?.last_extend_id };
    dispatch(editJob(data)).then((res) => {
      if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, {
          variant: "success",
        });
        handleCancel();
        dispatch(getAllGoals(dispatchData));
      } else {
        enqueueSnackbar(res.payload.message, {
          variant: "error",
        });
        const resetJobs = initialJobs.map((job) => ({ ...job }));
        setEditedJobs(resetJobs);
      }
    });
  };

  const addNewJobNavigateFunction = () => {
    const passingObject = {
      goal: goal,
      newJobFieldRequired: true,
      adminView:adminView
    };
    navigate("/Appraisal-Management/add-goal", { state: passingObject });
  };

  const allJobsAlreadyMarked = editedJobs
    .filter((job) => !job.goal_job_striked)
    .every((job) => job.goal_job_completed === 1);

  const toggleMarkAllJobs = () => {
    // Check if ALL unstriked jobs are already marked
    const allMarked = editedJobs
      .filter((job) => !job.goal_job_striked)
      .every((job) => job.goal_job_completed === 1);
    console.log("allmarked", allMarked);

    const updatedJobs = editedJobs.map((job) =>
      job.goal_job_striked == 1
        ? job // Skip striked jobs
        : { ...job, goal_job_completed: allMarked ? 0 : 1 }
    );
    setEditedJobs(updatedJobs);
    checkForChanges(updatedJobs);
  };
  return (
    <Box display="flex" flexDirection="column" gap={0}>
      <Box
        px={1}
        pt={1}
        pb={1}
        display="flex"
        justifyContent="flex-start"
        gap={1}
        alignItems="center"
        sx={{
          position: "sticky",
          top: -8,
          zIndex: 2,
          backgroundColor: "#fff",
          flexWrap: "wrap",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Button
          disabled={jobActivityDisabled}
          sx={{
            minWidth: "130px",
            fontSize: "0.65rem",
            borderRadius: "4px",
            boxShadow: "none",
            "&:hover": {
              bgcolor: "primary.main",
              color: "white",
            },
          }}
          size="small"
          color="primary"
          variant="outlined"
          onClick={addNewJobNavigateFunction}
          startIcon={<Icon icon="gridicons:add" />}
        >
          Add New Job
        </Button>

        {/* <Button
          sx={{
            minWidth: "130px",
            fontSize: "0.65rem",
            borderRadius: "4px",
            boxShadow: "none",
            "&:hover": {
              bgcolor: "info.main",
              color: "white",
            },
          }}
          size="small"
          color="info"
          variant="outlined"
          onClick={toggleMarkAllJobs}
          startIcon={
            allJobsAlreadyMarked ? (
              <Icon icon="mdi:checkbox-blank-outline" />
            ) : (
              <Icon icon="mdi:checkbox-marked" />
            )
          }
        >
          {allJobsAlreadyMarked ? "Unmark All Jobs" : "Mark All Jobs"}
        </Button> */}

        {!editMode && (
          <Button
            disabled={jobActivityDisabled}
            sx={{
              minWidth: "130px",
              fontSize: "0.65rem",
              borderRadius: "4px",
              boxShadow: "none",
              "&:hover": {
                bgcolor: "secondary.main",
                color: "white",
              },
            }}
            size="small"
            color="secondary"
            variant="outlined"
            onClick={handleEditAll}
            startIcon={<Icon icon="raphael:edit" />}
          >
            Edit Job Details
          </Button>
        )}

        <Box>
          {changeDetected && (
            <Box display="flex" justifyContent="flex-end" gap={0}>
              <Button
                disabled={jobActivityDisabled}
                sx={{
                  minWidth: "130px",
                  fontSize: "0.65rem",
                  borderRadius: "4px",
                  boxShadow: "none",
                  "&:hover": {
                    bgcolor: "warning.main",
                    color: "white",
                  },
                }}
                size="small"
                color="warning"
                variant="outlined"
                onClick={handleUpdate}
                startIcon={<Icon icon="radix-icons:update" />}
              >
                Update Changes
              </Button>
            </Box>
          )}
        </Box>
        {(changeDetected || editMode) && (
          <Button
            disabled={jobActivityDisabled}
            sx={{
              minWidth: "130px",
              fontSize: "0.65rem",
              borderRadius: "4px",
              boxShadow: "none",
              "&:hover": {
                bgcolor: "success.main",
                color: "white",
              },
            }}
            size="small"
            color="success"
            variant="outlined"
            onClick={handleCancel}
            startIcon={<Icon icon="grommet-icons:revert" />}
          >
            Cancel Changes
          </Button>
        )}
      </Box>

      {/* CHECK BOX CONTENT AREA */}

      {editedJobs.map((job, index) => (
        <Box
          key={`${job?.goal_job_id}-${index}}`}
          display="flex"
          flexDirection="column"
          gap={0.5}
          mt={1}
        >
          {index !== 0 && (
            <Divider
              textAlign="center"
              sx={{
                fontSize: "0.8rem",
                fontWeight: 600,
                color: "primary.main",
                my: 0.5,
                "&::before, &::after": {
                  borderColor: "#ccc",
                },
              }}
            >
            </Divider>
          )}
          <Box display="flex" alignItems="center">
            <Checkbox
              disabled={
                job.goal_job_striked || jobActivityDisabled ? true : false
              }
              size="small"
              checked={job.goal_job_completed ? true : false}
              onChange={(e) =>
                handleJobFieldEdit(
                  job.goal_job_id,
                  "goal_job_completed",
                  e.target.checked
                )
              }
            />

            {editMode ? (
              <TextField
                disabled={job.goal_job_striked ? true : false}
                fullWidth
                size="small"
                value={job.goal_job_name}
                onChange={(e) =>
                  handleJobFieldEdit(
                    job.goal_job_id,
                    "goal_job_name",
                    e.target.value
                  )
                }
                inputProps={{ style: { fontSize: "0.9rem" } }}
              />
            ) : (
              <Box>
                <Typography
                  sx={{
                    textDecoration: job.goal_job_striked
                      ? "line-through"
                      : "none",
                    flex: 1,
                    textTransform: "capitalize",
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    fontSize: {
                      xs: "0.85rem",
                      sm: "0.9rem",
                    },
                    alignSelf: "center", 
                  }}
                >
                  {job.goal_job_name}
                </Typography>
              </Box>
            )}
          </Box>

          {editMode ? (
            <Box
              sx={{ display: "flex", alignItems: "center", pl: 4.8, gap: 1 }}
            >
              <TextField
                disabled={job.goal_job_striked ? true : false}
                inputProps={{ style: { fontSize: "0.75rem" } }}
                size="small"
                type="date"
                value={job.goal_job_start_date}
                onChange={(e) =>
                  handleJobFieldEdit(
                    job.goal_job_id,
                    "goal_job_start_date",
                    e.target.value
                  )
                }
              />
              <TextField
                disabled={job.goal_job_striked ? true : false}
                inputProps={{ style: { fontSize: "0.75rem" } }}
                size="small"
                type="date"
                value={job.goal_job_end_date}
                onChange={(e) =>
                  handleJobFieldEdit(
                    job.goal_job_id,
                    "goal_job_end_date",
                    e.target.value
                  )
                }
              />
            </Box>
          ) : (
            <Box sx={{ display: "flex", alignItems: "center", pl: 5, gap: 2 }}>
              <Typography
                label="Start Date"
                variant="caption"
                sx={{
                  color: "#888",
                  fontSize: {
                    xs: "0.68rem",
                    sm: "0.75rem",
                  },
                  textDecoration: job.goal_job_striked
                    ? "line-through"
                    : "none",
                }}
              >
                Start Date:{" "}
                {dayjs(job.goal_job_start_date).format("DD-MM-YYYY")}
              </Typography>
              <Typography
                label="End Date"
                variant="caption"
                sx={{
                  color: "#888",
                  fontSize: {
                    xs: "0.68rem",
                    sm: "0.75rem",
                  },
                  textDecoration: job.goal_job_striked
                    ? "line-through"
                    : "none",
                }}
              >
                End Date : {dayjs(job.goal_job_end_date).format("DD-MM-YYYY")}
              </Typography>
            </Box>
          )}

          {editMode && (
            <Box display="flex" sx={{ pl: 4.8 }}>
              {job.goal_job_striked ? (
                <Button
                  sx={{
                    display:adminView?"inline-flex":"none",
                    minWidth: "130px",
                    fontSize: "0.65rem",
                    borderRadius: "4px",
                    boxShadow: "none",
                    "&:hover": {
                      bgcolor: "success.main",
                      color: "white",
                    },
                  }}
                  size="small"
                  color="success"
                  variant="outlined"
                  onClick={(e) =>
                    handleJobFieldEdit(
                      job.goal_job_id,
                      "goal_job_striked",
                      false
                    )
                  }
                  startIcon={
                    <Icon icon="la:trash-restore-alt" width="21" height="20" />
                  }
                >
                  Recover Job
                </Button>
              ) : (
                <Button
                  sx={{
                    minWidth: "130px",
                    fontSize: "0.65rem",
                    borderRadius: "4px",
                    boxShadow: "none",
                    "&:hover": {
                      bgcolor: "error.main",
                      color: "white",
                    },
                  }}
                  size="small"
                  color="error"
                  variant="outlined"
                  onClick={(e) =>
                    handleJobFieldEdit(
                      job.goal_job_id,
                      "goal_job_striked",
                      true
                    )
                  }
                  startIcon={<Icon icon="mi:delete" />}
                >
                  Remove Job
                </Button>
              )}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default JobsSelectionArea;
